import React from "react";

import Filter from "../Filter/Filter";

import { TableSizeOptions } from "./constants";

import TableIcon from "../../assets/Icons/TableIcon.svg?react";
import { useTranslation } from "react-i18next";

type Props = {
  value?: number;
  onChange: (value?: number) => void;
};

const TableSizeFilter = React.memo(({ onChange, value }: Props) => {
  const { t } = useTranslation("translation");
  return (
    <Filter
      icon={<TableIcon />}
      label={t("table_size")}
      options={TableSizeOptions}
      value={value}
      onChange={onChange}
    />
  );
});

export default TableSizeFilter;
